module.exports = __webpack_public_path__ + "static/media/ear_diagram.dbb055a0.webp";